import auth from '@/config/auth.json'

// var code = 0
// function initAuth(auth, level = 1, fatherCode = 0) {
//   auth.map((item, index) => {
//     if (level <= 4) {
//       if (level == 1) {
//         item.code = (fatherCode + 100000 * (index + 1)).toString()
//       }
//       if (level == 2) {
//         item.code = (fatherCode + 10000 * (index + 1)).toString()
//       }

//       if (level == 3) {
//         item.code = (fatherCode + 1000 * (index + 1)).toString()
//       }

//       if (level == 4) {
//         item.code = (fatherCode + 100 * (index + 1)).toString()
//         code = parseInt(item.code)
//       }
//     } else {
//       code += 1
//       item.code = code.toString()
//     }

//     if (item.children) {
//       initAuth(item.children, level + 1, parseInt(item.code))
//     }
//   })

//   return auth
// }

function formartAuth(auths, codes = {}) {
  if (auths.length > 0) {
    auths.map(item => {
      if (!codes[item.name_en]) {
        codes[item.name_en] = { pAuthCode: item.codes[0], mAuthCode: item.codes[1], platform: item.platform ? item.platform : 0 }
      }
      if (item.children) {
        formartAuth(item.children, codes)
      }
    })
  }
  return codes
}

var authCode = formartAuth(auth)
export default authCode